jQuery(document).ready(function($) {

    $("body").on('click', '[data-toggle-accordion]', function (e) {

        e.preventDefault();
        e.stopPropagation(); // <-- evita que el click burbujee y dispare otros handlers de accordions ancestros

        const $accordion = $(this).closest('[data-accordion]');
        const $content = $accordion.children('[data-accordion-content]'); // hijo directo, no descendientes
        const content = $content.get(0);
        const isOpen = $accordion.hasClass('open');

        // Limpia cualquier transitionend pendiente de este content para que no se acumule
        $content.off('transitionend');

        if ($accordion.closest('.product').length) {
            setTimeout(() => {
                const offset = window.innerHeight * 0.3;
                const targetY = $accordion[0].getBoundingClientRect().top + window.scrollY - offset;
                window.scrollTo({ top: targetY, behavior: "smooth" });
            }, 500);
        }

        if ($accordion.closest('.subcategory-group').length) {

            const $container   = $accordion.parent();
            const $accordions  = $container.children('[data-accordion]');
            const $opened      = $accordions.filter('.open');

            const openAccordion = ($acc) => {
                const $cnt = $acc.children('[data-accordion-content]');
                const el = $cnt.get(0);
                $cnt.off('transitionend');
                $cnt.css('height', el.scrollHeight + 'px');
                $cnt.one('transitionend', function (ev) {
                    if (ev.target !== el) return; // ignora transitionend burbujeado de hijos internos
                    $cnt.css('height', 'auto');
                });
                $acc.addClass('open');
            };

            const closeAccordion = ($acc) => {
                const $cnt = $acc.children('[data-accordion-content]');
                const el = $cnt.get(0);
                $cnt.off('transitionend');
                // Si estaba en auto, fijar primero su altura real en px antes de animar a 0
                const currentHeight = el.style.height === 'auto' || !el.style.height
                    ? el.scrollHeight
                    : el.getBoundingClientRect().height;
                $cnt.css('height', currentHeight + 'px');
                el.offsetHeight; // forzar reflow
                $cnt.css('height', '0px');
                $acc.removeClass('open');
            };

            if (isOpen) {
                if ($opened.length === 1) {
                    const $next = $accordion.nextAll('[data-accordion]:not(.hidden)').first();
                    const $target = $next.length ? $next : $accordions.first();
                    if ($accordions.length === 1) return;
                    closeAccordion($accordion);
                    openAccordion($target);
                } else {
                    closeAccordion($accordion);
                    if ($accordions.filter('.open').length === 0) {
                        openAccordion($accordions.first());
                    }
                }
            } else {
                $opened.each(function(){ closeAccordion($(this)); });
                openAccordion($accordion);
            }

        } else {

            // Cerrar solo los acordeones HERMANOS DIRECTOS (mismo nivel) que estén abiertos
            $accordion.siblings('[data-accordion].open').each(function () {
                const $otherAccordion = $(this);
                const $otherContent = $otherAccordion.children('[data-accordion-content]');
                const otherEl = $otherContent.get(0);
                $otherContent.off('transitionend');

                const currentHeight = otherEl.style.height === 'auto' || !otherEl.style.height
                    ? otherEl.scrollHeight
                    : otherEl.getBoundingClientRect().height;

                $otherContent.css('height', currentHeight + 'px');
                otherEl.offsetHeight;
                $otherContent.css('height', '0px');
                $otherAccordion.removeClass('open');
            });

            if (isOpen) {
                const currentHeight = content.style.height === 'auto' || !content.style.height
                    ? content.scrollHeight
                    : content.getBoundingClientRect().height;

                $content.css('height', currentHeight + 'px');
                content.offsetHeight;
                $content.css('height', '0px');
                $accordion.removeClass('open');
            } else {
                $content.css('height', content.scrollHeight + 'px');
                $content.one('transitionend', function (ev) {
                    if (ev.target !== content) return; // clave: ignora burbujeo de hijos internos
                    $content.css('height', 'auto');
                });
                $accordion.addClass('open');
            }
        }

    });
});